import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Tag from '../Tag';
import styles from './styles.module.scss';

const TagList = ({ tags, displayKey, onRemove, className }) => {
  const ref = useRef([]);
  useEffect(() => {
    // scroll to right so last tag is in view
    ref.current = ref.current.slice(0, tags.length);
    if (ref.current?.length)
      ref.current[ref.current.length - 1].scrollIntoView({
        behavior: 'smooth',
      });
  }, [tags]);

  return (
    <div
      className={cn(styles.tagList, className, {
        [styles.empty]: !tags.length,
      })}
    >
      {tags.map((tag, i) => (
        <Tag
          key={tag[displayKey]}
          id={tag.id}
          title={tag[displayKey]}
          onRemove={onRemove}
          ref={(el) => {
            ref.current[i] = el;
          }}
        />
      ))}
    </div>
  );
};

TagList.propTypes = {
  tags: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onRemove: PropTypes.func,
  displayKey: PropTypes.string,
  className: PropTypes.string,
};
TagList.defaultProps = {
  onRemove: null,
  displayKey: 'name',
  className: null,
};

export default TagList;
